<svg id="clock" viewBox="0 0 100 100">
  <circle id="clockbackground" cx="50" cy="50" r="45" istag="clockbackground"/>
  <g id="hands">
    <rect id="hourhand" x="48.5" y="12.5" width="5" height="40" rx="2.5" ry="2.55" />
    <rect id="minutehand" x="48" y="12.5" width="3" height="40" rx="2" ry="2"  />
    <rect id="sechand" x="48" y="12.5" width="1" height="40" rx="2" ry="2" />
  </g>
</svg>
